export const HIGHEST_OI = "HIGHEST_OI";
export const HIGHEST_OI_STREAM = "HIGHEST_OI_STREAM";
